import React, { useMemo, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { useToast } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';
import useDetailFetch from '../../../../hooks/useDetailFetch';

const CommunicationLogDetails = () => {
  const { logId } = useParams();
  const decodedId = logId ? atob(logId) : logId;
  const id = decodedId ? decodedId.replace(/\D/g, '') : '';
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [showDelete, setShowDelete] = useState(false);

  const url = id ? `${API_DOMAIN}${API_ROUTES.customerCommunicationLog}${id}/` : null;
  const { data: log, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!log) return [];
    const excluded = ['id', 'created_at', 'updated_at'];
    return Object.keys(log)
      .filter(k => !excluded.includes(k))
      .map(k => ({ label: k.charAt(0).toUpperCase() + k.slice(1).replace(/_/g, ' '), field: k }));
  }, [log]);

  const handleDelete = async () => {
    try {
      await axios.delete(`${API_DOMAIN}${API_ROUTES.customerCommunicationLog}${id}/`);
      showToast('Communication log deleted successfully', 'success');
      navigate('/customer/communication-log/list');
    } catch (error) {
      console.error('Error deleting communication log:', error);
      showToast('Error deleting communication log', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={log}
        columns={columns}
        loading={loading}
        entityName="Communication Log"
        listPath="/customer/communication-log/list"
        editPath={`/customer/communication-log/input/${btoa(logId)}`}
        onDelete={() => setShowDelete(true)}
      />
      <ConfirmModal
        show={showDelete}
        title="Delete Communication Log"
        message="Are you sure you want to delete this communication log? This action cannot be undone."
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
      />
    </div>
  );
};

export default CommunicationLogDetails;
